import { create } from './Create/Create.i18n.en'
import { update } from './Update/Update.i18n.en'

export const detergentHistories = {
  create,
  update,
}
